export function PremiumLetter() {
  return (
    <section className="prem-letter">
      <div className="shell">
        <div className="prem-letter-card">
          <div className="prem-letter-head">
            <span className="prem-letter-stamp">
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img src="/kamibot-character/kamibot-portrait.png" alt="" />
            </span>
            <div>
              <span className="prem-letter-eyebrow">A LETTER FROM 카미봇</span>
              <h3 className="prem-letter-title gowun">받아주실 분께,</h3>
            </div>
          </div>

          <div className="prem-letter-body gowun">
            <p>
              사실 이 페이지를 만드는 데 한참 걸렸어요.
              유료 구독을 별로 좋아하지 않아서요.
              뭔가 돈을 받는 게 미안하기도 하고,
              모든 분께 가능한 한 많은 걸 무료로 열어두고 싶었거든요.
            </p>

            <p>
              그런데 카미봇이 점점 커지면서, 음성 합성도 늘어나고,
              AI 응답도 늘어나고, 음악도 더 많이 틀어주고…
              매달 청구서가 자라요. 한 사람이 만든 봇치고는 좀 무서울 정도로요.
            </p>

            <p>
              그래서 결심했어요.
              &ldquo;구독해주시면 더 좋은 카미봇을 드릴게요&rdquo;가 아니라,
              <br />
              <b>&ldquo;실제로 비용이 많이 드는 자리&rdquo;에만 프리미엄을 두자고요.</b>
            </p>

            <p>
              <em>
                지금 무료로 쓰시는 기능은 유료가 되어도 계속 무료로 둘게요. 약속이에요.
              </em>
            </p>

            <p>
              혹시 멤버십에 가입해주신다면, 그건 기능을 사는 게 아니라,
              <b> 카미봇을 살려두는 것에 가까울 거예요.</b>
              잠긴 거 풀려고 결제하지 마시고,
              &ldquo;이 친구 계속 봤으면 좋겠네&rdquo; 하실 때만 들어와주세요.
            </p>

            <p className="shy">
              부담 없이, 무료로도 오래 함께해주세요.
              그게 저는 가장 좋아요.
            </p>

            <div className="prem-letter-sig">
              <span className="sig-line">— 카미봇 드림</span>
              <span className="sig-doodle">✦</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
